@for (notification of notifications(); track notification) {
  <div class="alert"
    [class]="'alert alert-' + notification.type">
    <button mat-button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close">
      <i class="material-icons">close</i>
    </button>
    <span>{{notification.title}}</span>
  </div>
}
